import { createSlice } from "@reduxjs/toolkit";

const initialExperimentState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  lastError: null,
  filteredEntities: "",
  experimentFetchedById: "",
  experimentChartById: "",
  companyRegistrationData: ""
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const companyRegistration = createSlice({
  name: "companyRegistration",
  initialState: initialExperimentState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        state.entities = [];
      } else {
        state.actionsLoading = false;
        state.entities = [];
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    companyCreated: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.companyRegistrationData = action.payload;
      state.error = null;
    }
  }
});
